const DEFAULT_TRACE_TARGETS = ["localhost", "/"];

export function parseTracePropagationTargets(
  rawValue: string | undefined,
  fallback: Array<string> = DEFAULT_TRACE_TARGETS
): Array<string> {
  if (!rawValue) {
    return [...fallback];
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (!Array.isArray(parsed)) {
      console.warn("NEXT_PUBLIC_TRACE_TARGETS must be an array, using default");
      return [...fallback];
    }

    const normalized = parsed.filter(
      (value): value is string => typeof value === "string" && value.length > 0
    );

    if (normalized.length === 0) {
      console.warn("NEXT_PUBLIC_TRACE_TARGETS must contain strings, using default");
      return [...fallback];
    }

    return normalized;
  } catch (error) {
    const message = error instanceof Error ? error.message : "Unknown error";
    console.warn("Invalid NEXT_PUBLIC_TRACE_TARGETS, using default:", message);
    return [...fallback];
  }
}

export function getDefaultTracePropagationTargets(): Array<string> {
  return [...DEFAULT_TRACE_TARGETS];
}
